/**
 * Empty State Component
 * Beautiful empty states for when there's no data
 */

import React from "react";
import "./Loaders.css";

export const EmptyState = ({
  icon = "—",
  title = "No data yet",
  message = "There's nothing to show here right now",
  action = null,
}) => (
  <div className="card">
    <div className="empty-state">
      <div className="empty-state-icon">{icon}</div>
      <div className="empty-state-title">{title}</div>
      <div className="empty-state-message">{message}</div>
      {action && (
        <div className="empty-state-action">
          {action &&
          typeof action === "object" &&
          !React.isValidElement(action) &&
          action.label ? (
            <button className="btn btn-primary" onClick={action.onClick}>
              {action.label}
            </button>
          ) : (
            action
          )}
        </div>
      )}
    </div>
  </div>
);

export const ErrorState = ({ error, onRetry, icon = "!" }) => (
  <div className="card">
    <div className="empty-state">
      <div className="empty-state-icon">{icon}</div>
      <div className="empty-state-title">Something went wrong</div>
      <div className="empty-state-message">{error}</div>
      {onRetry && (
        <div className="empty-state-action">
          <button className="btn btn-primary" onClick={onRetry}>
            Try Again
          </button>
        </div>
      )}
    </div>
  </div>
);

export const NoAccessState = () => (
  <div className="card">
    <div className="empty-state">
      <div className="empty-state-icon">Lock</div>
      <div className="empty-state-title">Access Denied</div>
      <div className="empty-state-message">
        You don't have permission to access this resource
      </div>
    </div>
  </div>
);
